import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "export",
  "use": "export-usage",
  "viewBox": "0 0 58 58",
  "content": "<symbol viewBox=\"0 0 58 58\" id=\"export\"><title>资源 42</title><g id=\"export_图层_2\" data-name=\"图层 2\"><g id=\"export_图层_1-2\" data-name=\"图层 1\"><path d=\"M25.38,30.8a1.82,1.82,0,0,0,1.81,1.81H51.81L47.22,37.2a1.81,1.81,0,0,0,2.57,2.57l7.61-7.61.07-.07a1.82,1.82,0,0,0,0-2.56l-.07-.07-7.61-7.62a1.81,1.81,0,0,0-2.57,2.57L51.81,29H27.19a1.81,1.81,0,0,0-1.81,1.8Zm0,0\" /><path d=\"M47.13,1.81A1.81,1.81,0,0,0,45.31,0H15.49l-.32,0a1.8,1.8,0,0,0-1.42.53L.69,13.61a1.3,1.3,0,0,0-.14.16A1.81,1.81,0,0,0,0,15.07V56.19A1.81,1.81,0,0,0,1.81,58h43.5a1.82,1.82,0,0,0,1.81-1.81V45.31a1.81,1.81,0,1,0-3.63,0v9.06H3.62V18.13H16.31a1.81,1.81,0,0,0,1.81-1.81V3.62H43.5V16.32a1.81,1.81,0,0,0,3.63,0ZM14.5,14.5H4.93L14.5,4.93Zm0,0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/export.svg
// module id = uPuA
// module chunks = 264